import { Controller } from 'stimulus'

// The phone screens' sticky header (layouts/mobile, on the page wrapper).
// Docks the page's notices and errors (mobile/_flash) along the bottom of the
// header, so they're in view however far down the page opens, and clears a
// notice after a few seconds; an error stays until X. Also keeps a linked-to
// element, such as the box Sample Storage reopens at, from landing under the
// header (--mb-appbar-h feeds scroll-margin-top in _mobile.scss).
const NOTICE_MS = 4000
const FOLD_MS = 300

export default class extends Controller {
  static targets = ['flash']

  connect() {
    this.timers = []
    this.header = this.element.querySelector('.mb-appbar')
    if (this.header) this.flashTargets.forEach(flash => this.dock(flash))
    this.measure()
    this.revealAnchor()
  }

  disconnect() {
    this.timers.forEach(timer => clearTimeout(timer))
  }

  dismiss(event) {
    this.fold(event.currentTarget.closest('.mb-flash'))
  }

  dock(flash) {
    this.header.appendChild(flash)
    flash.classList.add('is-docked')
    if (flash.dataset.auto === 'true') this.timers.push(setTimeout(() => this.fold(flash), NOTICE_MS))
  }

  fold(flash) {
    if (!flash || flash.classList.contains('is-gone')) return

    flash.classList.add('is-gone')
    this.timers.push(setTimeout(() => {
      flash.remove()
      this.measure()
    }, FOLD_MS))
  }

  measure() {
    if (!this.header) return
    document.documentElement.style.setProperty('--mb-appbar-h', `${this.header.offsetHeight}px`)
  }

  // The browser may have scrolled to the #anchor before the header was
  // measured (and before a message made it taller), so scroll again.
  revealAnchor() {
    const id = decodeURIComponent(window.location.hash.slice(1))
    const target = id && document.getElementById(id)
    if (target && this.header && !this.header.contains(target)) target.scrollIntoView({ block: 'start' })
  }
}
